import { __ } from '@/hub-shared/utils/i18n';

export const NOTIFICATION_GROUP_LABELS = (): Record<string, string> => ({
  missions: __('Missions'),
  diligences: __('Diligences'),
  companies: __('Sociétés'),
});

export const NOTIFICATION_PARENT_LABELS = (): Record<string, { label: string; description: string }> => ({
  'mission.status_notifications': {
    label: __('Notifications de mission'),
    description: __(
      'Active ou désactive les notifications liées aux étapes clés du cycle de mission (révision, supervision, génération, clôture, signature, archivage).',
    ),
  },
});

export const NOTIFICATION_EVENT_LABELS = (): Record<string, { label: string; description: string }> => ({
  'mission.assigned': {
    label: __('Mission assignée'),
    description: __('Quand une mission vous est assignée ou réassignée.'),
  },
  'diligence.note.published': {
    label: __('Commentaire sur une diligence'),
    description: __('Quand un collaborateur publie un commentaire sur une diligence.'),
  },
  'diligence.anomaly_created': {
    label: __('Anomalie de diligence'),
    description: __('Quand une diligence passe en anomalie sur une mission.'),
  },
  'mission.renewable': {
    label: __('Mission renouvelable'),
    description: __('Quand une mission peut être relancée pour un nouveau rapport.'),
  },
  'mission.ready_to_revise': {
    label: __('Peut réviser'),
    description: __('Quand tous les cycles de diligence sont complétés et prêts pour la révision.'),
  },
  'mission.ready_for_review': {
    label: __('Peut superviser'),
    description: __('Quand la mission passe en statut complétée et la supervision peut commencer.'),
  },
  'mission.ready_to_generate': {
    label: __('Peut générer'),
    description: __('Quand la mission est prête pour la génération du rapport.'),
  },
  'mission.ready_to_close': {
    label: __('Peut clôturer'),
    description: __('Quand une mission peut être clôturée après génération du rapport.'),
  },
  'mission.ready_to_sign': {
    label: __('Peut signer'),
    description: __('Quand une mission attend une signature.'),
  },
  'mission.ready_to_archive': {
    label: __('Peut archiver'),
    description: __('Quand une mission signée peut être archivée.'),
  },
  'mission.form_ready_for_review': {
    label: __('Formulaire VS complété'),
    description: __('Notification historique — formulaire VS complété.'),
  },
  'mission.restored': {
    label: __('Mission rouverte'),
    description: __('Notification historique — mission rouverte.'),
  },
  'diligence.anomaly_resolved': {
    label: __('Anomalie résolue'),
    description: __('Notification historique — anomalie levée.'),
  },
  'report.generated': {
    label: __('Rapport généré'),
    description: __('Notification historique — rapport généré.'),
  },
  'workfile.note.published': {
    label: __('Note de dossier publiée'),
    description: __('Notification historique — note de dossier.'),
  },
  'review.requested': {
    label: __('Revue demandée'),
    description: __('Notification historique — revue demandée.'),
  },
  'mission.status_changed': {
    label: __('Changement de statut de mission'),
    description: __('Notification historique de changement de statut.'),
  },
  'profile.public_source.import_failed': {
    label: __('Échec d’import de source publique'),
    description: __(
      'Quand un import automatique de données publiques (Annuaire, ADEME, IGN…) échoue pour une société.',
    ),
  },
});
